let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h36CF")).then(() => parcelRequire('30DRG'));